import React from 'react';


export function useSubFundsPortfolio() {
  const [expandedSubFunds, setExpandedSubFunds] = React.useState<string[]>([]);

  function collapseSubFund(id: string) {
    setExpandedSubFunds(prev => prev.filter(p => p !== id));
  }

  function expandSubFund(id: string) {
    setExpandedSubFunds(prev => [...prev, id]);
  }

  return {
    expandedSubFunds,
    collapseSubFund,
    expandSubFund,
  };
}